export default "__VITE_ASSET__Dx5ZzXNr__"